import React, { Component } from "react";
import { NavLink, Link, Route } from 'react-router-dom';
import LeftNavContent from '../Commons/LeftNavContent';
import ItemsNews from './ItemsNews';
import NewsItem from './NewsItem';

export default (props) => {
    return (
        <div className="vertical-scrolling page sectionInformation">
            <div className="container content">

                <LeftNavContent>
                    <h2 className="left-content__title">Новости</h2>
                </LeftNavContent>

                <div className="right-content native-scroll right-content-bottom right-content-width">
                    <div className="screen-outer-block-wrap native-scroll menu-content">
                        <div>

                            <Route exact path="/news" render={() => (<ItemsNews />)} />
                            <Route exact path="/news/:id" render={(props) => (<NewsItem match={props.match} />)} />

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

{/* <div className="big-button without-shadow button-action" style={{ height: "auto", textAlign: "center", marginTop: "30px", marginBottom: "30px" }}>
    <button
        className={false ? 'disabled' : ''}
        onClick={() => { }}>{false ? 'Загружается...' : 'Загрузить еще'}</button>
</div> */}


// WEBPACK FOOTER //
// ./src/components/News/index.js